export default {
  L_INTERNAL_TITLE: "Truy vấn nội bộ",
  L_EXTERNAL_TITLE: "Truy vấn bên ngoài",
  L_IDENTITY_SEARCH_TITLE: "Danh sách tìm kiếm theo CCCD",
  L_SAILOR_SEARCH_TITLE: "Danh sách tìm kiếm theo mã thuyền viên",
  L_SHIP_SEARCH_TITLE: "Danh sách tìm kiếm theo biển số tàu",
  L_IDENTITY_REPONSE_TITLE: "Danh sách phản hồi truy vấn CCCD",
  L_SAILOR_RESPONSE_TITLE: "Danh sách phản hồi truy vấn thuyền viên",
  L_VIOLATION_RESPONSE_TITLE: "Danh sách phản hồi truy vấn tàu thuyền vi phạm",
  L_EXPORT_REQUEST_TITLE: "Thực hiện xuất truy vấn",
  L_SELECTED_REQUEST_TITLE: "Danh sách truy vấn đã chọn",
  L_NO_SELECTED_REQUEST: "Không có truy vấn nào được chọn",
  L_CANCEL: "Hủy",
  L_CONFIRM: "Xác nhận",
  L_SELECT_USER_TITLE: "Người dùng để đọc dữ liệu",
  L_SYSTEM_IN_CHARGE: "Hệ thống phụ trách",

  MSG_NO_USER_SELECTED: "Vui lòng chọn người dùng để đọc dữ liệu",

  OBJ_INTERNAL_TABLE_COL: {
    requestID: "ID truy vấn",
    application: "Hệ thống truy vấn",
    createdAt: "Thời gian tạo mới",
    responseAt: "Thời gian phản hồi",
    status: "Trạng thái truy vấn",
    responseStatus: "Trạng thái phản hồi",
    action: "Thao tac",
  },

  OBJ_INTERNAL_INPUT_SEARCH: {
    fromDate: "Từ ngày",
    toDate: "Đến ngày",
    search: "Tìm kiếm: ID truy vấn",
    reqSystem: "Hệ thống truy vấn",
    reqStatus: "Trạng thái truy vấn",
  },
  OBJ_INTERNAL_IMPORT: {
    title: "Tải lên dữ liệu phản hồi",
    listImport: "Phản hồi truy vấn đã tải lên",
  },

  OBJ_EXTERNAL_TABLE_COL: {
    requestName: "Tên truy vấn",
    appCode: "Mã ứng dụng",
    uploadAt: "Thời gian tải lên",
    responseAt: "Thời gian phản hồi",
    status: "Trạng thái",
  },

  OBJ_EXTERNAL_INPUT_SEARCH: {
    search: "Tìm kiếm: ID truy vấn",
    responseStatus: "Trạng thái trả lời truy vấn",
  },

  OBJ_EXTERNAL_IMPORT: {
    title: "Tải lên dữ liệu truy vấn",
    listImport: "Truy vấn đã tải lên",
  },

  OBJ_RESPONSE_STATUS: {
    processing: "Đang chờ xử lý",
    success: "Thành công",
    error: "Thất bại",
    reject: "Từ chối",
    accept: "Xác nhận",
  },

  OBJ_SAILOR_COL: {
    code: "Id Thuyền viên",
    name: "Họ và tên thuyền viên",
    identity: "CCCD",
    responseAt: "Thời gian phản hồi",
    source: "Nguồn dữ liệu",
    status: "Trạng thái",
  },

  OBJ_SHIP_COL: {
    name: "Tên tàu thuyền",
    imo: "IMO",
    mmsi: "MMSI",
    responseAt: "Thời gian phản hồi",
    source: "Nguồn dữ liệu",
    status: "Trạng thái",
    licensePlate: "Biển số tàu",
  },

  OBJ_INPUT_SEARCH: {
    fromDate: "Từ ngày",
    toDate: "Đến ngày",
    searchById: "Tìm kiếm: CCCD",
    searchByCode: "Tìm kiếm: Mã thuyền viên",
    searchByShip: "Tìm kiếm: Biển số tàu",
  },
};
